import { FormInstance } from "antd";
import React from "react";
import { ZAttrComponentEditor } from "src/common/attrEdit";
import {
  ChildEntitiesProps,
  FormulaProps,
  FormulaWithFinancialProps,
  ObjectRefProps,
  MaskedInputProps,
  InputProps,
  InputNumberProps,
  ImageCarouselProps,
  UploaderProps,
  TextAreaProps,
  SelectProps,
  PersonSelectProps,
  FinancialInputProps,
} from "./componentProps";
import { ParamsEditorInfo2 } from "./ParamsEditorInfo2";

type EdCmpProps = ParamsEditorInfo2 & {
  attrTypeName: string;
  form: FormInstance;
};

const propsMap = (
  props: EdCmpProps,
): Partial<Record<ZAttrComponentEditor["editor"], React.ReactNode>> => ({
  ChildEntities: <ChildEntitiesProps attrTypesDict={props.attrTypesDict} />,
  Formula: <FormulaProps objectId={props.objectId} />,
  FormulaWithFinancial: <FormulaWithFinancialProps props={props} />,
  ObjectRefTable: <ObjectRefProps form={props.form} />,
  ObectRefSelector: <ObjectRefProps form={props.form} />,
  MaskedInput: <MaskedInputProps />,
  Input: <InputProps />,
  InputNumber: <InputNumberProps typeName={props.attrTypeName} />,
  ImageCarousel: <ImageCarouselProps form={props.form} />,
  Uploader: <UploaderProps form={props.form} />,
  TextArea: <TextAreaProps />,
  Select: <SelectProps typeName={props.attrTypeName} />,
  PersonSelect: <PersonSelectProps form={props.form} />,
  FinancialInput: <FinancialInputProps />,
});

export const defEditorComponentProps = (
  editorName: ZAttrComponentEditor["editor"],
  editorProps: EdCmpProps,
) => {
  const propsCmp = propsMap(editorProps)[editorName];
  return propsCmp ?? null;
};
